import React from 'react'
import Outline24Pencil from '@mds/mds-icons/icons/svg/outline-24-pencil.svg'
import LibraryTableDownloadsColumn from './LibraryTableDownloadsColumn'
import LibraryTableActionsColumn from './LibraryTableActionsColumn'

const LibraryTableRow = ({addReportRequest, summaryEntry, generators, removeReportRequest, editReportNameClicked, datasets = []}) => {
  return (
    <tr>
      <td>
        { 
          new Date(summaryEntry.createdDate)
          .toLocaleDateString('en-US', 
            {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
            }
          )
        }
      </td>
      <td>
        {summaryEntry.name}
        <button className="edit" onClick={() => editReportNameClicked(summaryEntry)}>
          <img src={Outline24Pencil} alt="edit" />
        </button>
      </td>
      <td>{summaryEntry.datasetName}</td>
      <td className="downloads-column">
        <LibraryTableDownloadsColumn addReportRequest={addReportRequest} summaryEntry={summaryEntry} generators={generators.filter(generator => generator.datasetId === summaryEntry.datasetId)} />
      </td>
      <td className="action-column">
        <LibraryTableActionsColumn summaryEntry={summaryEntry} removeReportRequest={removeReportRequest} editReportNameClicked={editReportNameClicked} datasets={datasets} />
      </td>
    </tr>
  )
}

export default LibraryTableRow
